<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { authApi } from '@/api/client'
import { useAuthStore } from '@/store/auth'
import { useStatusStore } from '@/store/status'

const { redirectLogin } = useAuthStore()
const statusStore = useStatusStore()
const route = useRoute()
const router = useRouter()

onMounted(async () => {
  const isValidUser = await redirectLogin({
    accessToken: route.query.accessToken as string,
    organizationId: route.query.organizationId as string | undefined
  })
  if (isValidUser) {
    const locations = await authApi.getLocations()
    const currentLocation = locations.find((l: any) => l.id === route.query.locationId)
    if (currentLocation) {
      const auth = useAuthStore()
      auth.selectLocation(currentLocation)
      await statusStore.performInitialSync()
      router.push({ name: 'employees' })
    } else {
      router.push({ name: 'locations' })
    }
  } else {
    router.push({ name: 'login' })
  }
})
</script>
